import {
  isButtonConfig,
  isCustomComponentConfig,
  isDropdownConfig,
  isExportConfig,
  isToggleConfig,
  isDividerConfig,
} from '@ardoq/view-settings';
import type { SettingsConfig } from '@ardoq/view-settings';
import { Button } from './Button';
import { Dropdown } from './Dropdown';
import { ExportButton } from './ExportButton';
import { Toggle } from './Toggle';
import { SettingsBarSeparator } from './SettingsBarSeparator';
import { ViewIds } from '@ardoq/api-types';
import { NewerOptionButton } from './NewerOptionButton';
import { NewerToggle } from './NewerToggle';
import { NewerDropdown } from './NewerDropdown';
import type { I18nLocale } from '@ardoq/i18n';

type OptionsGroupProperties = {
  viewId: ViewIds;
  options: SettingsConfig[];
  isViewpointModeViewPaneHeader?: boolean;
  i18nLocale: I18nLocale;
};
const OptionsGroup = ({
  viewId,
  options,
  isViewpointModeViewPaneHeader,
  i18nLocale,
}: OptionsGroupProperties) => (
  <>
    {options.map(option => {
      if (isToggleConfig(option)) {
        return isViewpointModeViewPaneHeader ? (
          <NewerToggle key={option.id} viewId={viewId} {...option} />
        ) : (
          <Toggle key={option.id} viewId={viewId} {...option} />
        );
      }
      if (isButtonConfig(option)) {
        return isViewpointModeViewPaneHeader ? (
          <NewerOptionButton key={option.id} {...option} />
        ) : (
          <Button key={option.id} {...option} />
        );
      }

      if (isExportConfig(option)) {
        return (
          <ExportButton
            key={option.id}
            viewId={viewId}
            {...option}
            i18nLocale={i18nLocale}
          />
        );
      }

      if (isDropdownConfig(option)) {
        const DropdownComponent = isViewpointModeViewPaneHeader
          ? NewerDropdown
          : Dropdown;

        return (
          <DropdownComponent
            key={option.id}
            {...option}
            clickNamespace={`view modifier bar dropdown ${viewId}`}
          />
        );
      }

      if (isCustomComponentConfig(option)) {
        const Component = option.component;
        return <Component key={option.id} {...(option.componentProps || {})} />;
      }

      if (isDividerConfig(option)) {
        return (
          <SettingsBarSeparator
            data-testid="settings-bar-separator"
            key={option.id}
          />
        );
      }

      return null;
    })}
  </>
);

export { OptionsGroup };
